module.exports = __webpack_public_path__ + "media/images/svg/jobs/businessman-71ba4d93c402c0b0b4243544a5929c4d.svg";